// put style here
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    deleteFileTextContainer: {
      textAlign: 'center',
      color: '#E63C3C',
      marginTop: 7,
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 14,
      marginBottom: 5,
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        textAlign: 'center',
      },
    },
  })
);
